// extracted by mini-css-extract-plugin
export default {"container":"SpecificParishBookPersonView_container__IQkvp","pageHeader":"SpecificParishBookPersonView_pageHeader__MK9Hx","form":"SpecificParishBookPersonView_form__mxMd0"};